import { motion } from "framer-motion";

export const WhatsAppFAB = () => {
  return (
    <motion.a
      href="https://wa.me/595972919569"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Escribir por WhatsApp"
      initial={{ opacity: 0, scale: 0.7, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ type: "spring", stiffness: 130, damping: 15, delay: 1.2 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-50 group flex items-center gap-3"
    >
      <span className="hidden md:inline-flex px-3 py-2 bg-black border border-divider font-mono text-[10px] uppercase tracking-[0.25em] text-white/80 group-hover:text-rust group-hover:border-rust transition-colors">
        Hablemos
      </span>
      <span className="relative flex items-center justify-center w-14 h-14 bg-rust text-black shadow-[0_10px_30px_rgba(204,73,55,0.35)]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          width="24"
          height="24"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M19.11 17.13c-.28-.14-1.66-.82-1.92-.91-.26-.09-.45-.14-.63.14-.19.28-.72.91-.88 1.09-.16.19-.32.21-.6.07-.28-.14-1.17-.43-2.23-1.38-.82-.73-1.38-1.63-1.54-1.9-.16-.28-.02-.43.12-.57.13-.12.28-.32.42-.48.14-.16.19-.28.28-.46.09-.19.05-.35-.02-.49-.07-.14-.63-1.52-.86-2.08-.23-.55-.46-.48-.63-.49l-.54-.01a1.03 1.03 0 0 0-.75.35c-.26.28-.98.96-.98 2.34s1.01 2.72 1.15 2.9c.14.19 1.99 3.04 4.83 4.26.68.29 1.21.46 1.62.59.68.22 1.3.19 1.79.11.55-.08 1.66-.68 1.9-1.34.23-.66.23-1.22.16-1.34-.07-.12-.26-.19-.54-.33Zm-5.09 6.94h-.01a9.85 9.85 0 0 1-5.02-1.38l-.36-.21-3.74.98 1-3.64-.23-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.9-9.88 2.64 0 5.13 1.03 7 2.9a9.84 9.84 0 0 1 2.9 6.99c0 5.45-4.44 9.88-9.93 9.88Zm8.42-18.3A11.79 11.79 0 0 0 14.02 2.4c-6.55 0-11.87 5.32-11.88 11.86 0 2.09.55 4.13 1.58 5.93L2 26l5.95-1.56a11.87 11.87 0 0 0 5.68 1.44h.01c6.55 0 11.87-5.32 11.88-11.87a11.8 11.8 0 0 0-3.48-8.44Z" />
        </svg>
      </span>
    </motion.a>
  );
};
